import axios from 'axios';

const getCotacoesList = params => axios.get('/cotacoes-fretes/list', {
  params,
});

export default {
  getCotacoesList,
};
